import { render, staticRenderFns } from "./SeagullTransfer.vue?vue&type=template&id=7e56fc91&"
import script from "./SeagullTransfer.vue?vue&type=script&lang=js&"
export * from "./SeagullTransfer.vue?vue&type=script&lang=js&"
import style0 from "./SeagullTransfer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports